import _str from "shared/util/_str";

export const STATUS_CODES = {
	ERROR: 100,
	PASSWORD: 104,
	DELETED: 105,
	NO_USER: 106,
	OTHER: 107,
	DISABLED: 108,
	PASSWORD_EXPIRED: 144,
	UNDERAGE: 145,
	NEEDS_2FA: 147,
	BAD_2FA: 148,
	PROVISIONAL: 149,
	BLACKLISTED: 150,
	NEED_CAPTCHA: 151,
	NEED_SMS_2FA: 152,
};

export const STATUS_MESSAGES = {
	[STATUS_CODES.ERROR]: _str("Something went wrong, please try again later"),
	[STATUS_CODES.PASSWORD]: _str("That email or password is incorrect."),
	[STATUS_CODES.DELETED]: _str("That email or password is incorrect."),
	[STATUS_CODES.NO_USER]: _str("That email or password is incorrect."),
	[STATUS_CODES.OTHER]: _str("Something went wrong, please try again later"),
	[STATUS_CODES.DISABLED]: null, // Custom handler.
	[STATUS_CODES.PASSWORD_EXPIRED]: _str("Your password has expired! Check your email for a link to reset your password."),
	[STATUS_CODES.UNDERAGE]: _str("You must be over 18 to use OkCupid."),
	[STATUS_CODES.NEEDS_2FA]: null, // Custom handler.
	[STATUS_CODES.BAD_2FA]: _str("Invalid authenticator code."),
	[STATUS_CODES.PROVISIONAL]: _str("Finish your profile on the App, then try again."),
	[STATUS_CODES.BLACKLISTED]: _str("Your account was suspended due to terms violation."),
	[STATUS_CODES.NEED_CAPTCHA]: null, // Custom handler.
	[STATUS_CODES.NEED_SMS_2FA]: null, // Custom handler.
};

export const CUSTOM_ERRORS = {
	FACEBOOK_EXITED: "FACEBOOK_EXITED",
};

export const DIRECT_LINKABLE_SCREENS = {
	PASSWORD_RESET: "reset_password",
	LANDING: "landing",
	CAPTCHA: "captcha",
	REACTIVATE: "reactivate",
};

export const SMS_SCREENS = {
	SMS_PHONE_INPUT: "SMS_PHONE_INPUT",
	SMS_SENDING_CODE: "SMS_SENDING_CODE",
	SMS_CODE_INPUT: "SMS_CODE_INPUT",
	SMS_VALIDATING_CODE: "SMS_VALIDATING_CODE",
	SMS_SUCCESS: "SMS_SUCCESS",
	SMS_TWO_FACTOR: "SMS_TWO_FACTOR",
};

export const SCREENS = {
	LOGIN: "LOGIN",
	PASSWORD_RESET: "PASSWORD_RESET",
	PASSWORD_SUBMIT: "PASSWORD_SUBMIT",
	REACTIVATE: "REACTIVATE",
	TWO_FACTOR: "TWO_FACTOR",
	CAPTCHA: "CAPTCHA",
	...SMS_SCREENS,
};

// this is for allowing going back in the modal
// some screens the user should not be able to go back to e.g. a loading screen
// but because of how the screens work in App.jsx we need to keep track of
// the previous go backable screen and not the actual previous screen
export const CUSTOM_PREVIOUS_SCREENS = {
	[SCREENS.SMS_PHONE_INPUT]: SCREENS.LOGIN,
	[SCREENS.SMS_SENDING_CODE]: SCREENS.SMS_PHONE_INPUT,
	[SCREENS.SMS_CODE_INPUT]: SCREENS.SMS_PHONE_INPUT,
	[SCREENS.SMS_VALIDATING_CODE]: SCREENS.SMS_CODE_INPUT,
	[SCREENS.SMS_TWO_FACTOR]: SCREENS.LOGIN,
};

export const SCREEN_SPEED = 400;

export default {
	STATUS_CODES,
	SCREENS,
	SCREEN_SPEED,
};



// WEBPACK FOOTER //
// ./src/apps/login/util/constants.js